import React, { useState, useEffect } from 'react';
import WebsiteHeader from '../components/website/WebsiteHeader';
import DomainsSection from '../components/website/DomainsSection';
import AstrologerSection from '../components/website/AstrologerSection';
import B2BSection from '../components/website/B2BSection';
import MatchmakingSection from '../components/website/MatchmakingSection';
import PowerSection from '../components/website/PowerSection';
import ContactSection from '../components/website/ContactSection';
import WebsiteFooter from '../components/website/WebsiteFooter';
import ScrollingPlanet from '../components/website/ScrollingPlanet';
import '../styles/website/LandingPage.css';

const WebsiteAboutPage = () => {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
      setScrollProgress((window.scrollY / totalHeight) * 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="landing-page" data-testid="website-about-page">
      <WebsiteHeader />
      <ScrollingPlanet scrollProgress={scrollProgress} />
      <div style={{ paddingTop: '60px' }} />
      <DomainsSection />
      <AstrologerSection />
      <B2BSection />
      <MatchmakingSection />
      <PowerSection />
      <ContactSection />
      <WebsiteFooter />
    </div>
  );
};

export default WebsiteAboutPage;
